import React from 'react';
import Shapes from 'Shapes';
import { getAvailabilityLabel, isAvailableNow } from 'App/models/dish';
var DishAvailability = function (_a) {
    var dish = _a.dish;
    if (isAvailableNow(dish)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "text-danger" }, "Obecnie niedost\u0119pny"),
        React.createElement("span", { className: "mt- 2 small" }, getAvailabilityLabel(dish))));
};
DishAvailability.propTypes = {
    dish: Shapes.restaurantMenuItemWithCategoryShape.isRequired,
};
export default DishAvailability;
